import { Link } from "react-router-dom/cjs/react-router-dom.min";
import Vacancytable from "../Dashboard/Vacancytable";
import { useEffect, useState } from "react";
import {
  FetchDashboardData,
  getTodayAgendaDetails,
} from "helpers/backend_helper";
import { Col, Row } from "reactstrap";
import { toast } from "react-toastify";
import FunnelChart from "./FunnelChart";
import DashboardDateTime from "./DashboardDateTime";
import cross from "../../assets/images/icon/cross.svg";
import arrow from "../../assets/images/icon/arrow.svg";
import DatePicker from "react-datepicker";
import { useMsal } from "@azure/msal-react";
import TimeToHire from "../Dashboard/TimeToHire";
import RangeTableComponent from "./RangeTableComponent";
import DropoutMatrix from "./DropoutMatrix";
import HiringCharts from "./HiringCharts";
import HiringAcceptanceChart from "./HiringAcceptanceChart";
import NewApplicantChart from "./NewApplicantChart";

import DemographicChart from "./DemographicChart";
import { decryptDataFromArray } from "helpers/EncDec";
import api from "../../api";
import { getUserToken } from "helpers/authHelper";
import { GetCompanyData } from "services/CompanyService";
import { useTranslation } from "react-i18next";
import moment from "moment";
import { getSubdomain,checkPermissionStatus } from "helpers/utils";

const Card = ({ imageSrc, title, value, units, link }) => (
  <div className="tabBox-wrapper">
    <Link to={link}>
      <div className="tab-details">
        <div className="d-flex align-items-center">
          <div className="tab-value">{value}</div>
          <div className="tab-ico ms-auto">
            <img src={imageSrc} alt={title} />
          </div>
        </div>
        <h2 className="tab-title">{title}</h2>
        {/*<div className="valueCounter d-flex align-items-center">
            <div className="candidate-value">
              <span>{units}</span>
            </div>
          </div>*/}
      </div>
    </Link>
  </div>
);

const RecruitmentDashboard = () => {
  const [dashboardData, setDashboardData] = useState("");
  const [agendaDetails, setAgendaDetails] = useState("");
  const [agendaDate, setAgendaDate] = useState(
    moment(new Date()).format("DD-MM-YYYY")
  );
  const [tabType, setTabType] = useState("current");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [errors, setErrors] = useState({});
  const [jobTitles, setJobTitles] = useState([]);
  const { t } = useTranslation();
  const subdomain = localStorage.getItem("subdomain") || "";


  useEffect(() => {
    getAgendaData();
  }, [agendaDate]);

  const saveDashboardFilterType = type => {
    let dashboardFilters = localStorage.getItem("dashboardFilters")
      ? JSON.parse(localStorage.getItem("dashboardFilters"))
      : {};
    dashboardFilters = {
      ...dashboardFilters,
      type: type,
    };
    localStorage.setItem("dashboardFilters", JSON.stringify(dashboardFilters));
  };

  const handleTabTypeChange = type => {
    setTabType(type);
    if (type !== "custom") {
      saveDashboardFilterType(type);
    }
  };

  const saveDashboardFilterDates = (start, end) => {
    let dashboardFilters = localStorage.getItem("dashboardFilters")
      ? JSON.parse(localStorage.getItem("dashboardFilters"))
      : {};
    dashboardFilters = {
      ...dashboardFilters,
      startDate: start || startDate,
      endDate: end || endDate,
    };
    localStorage.setItem("dashboardFilters", JSON.stringify(dashboardFilters));
  };

  async function getJobList(type, startDate, endDate) {
    try {
      const res = await api({
        method: "get",
        url: `${process.env.REACT_APP_API_URL}/admin/job/fetch-job-dashboard`,
        params: { type, startDate, endDate },
      });

      let responseData = res?.data;
      responseData = decryptDataFromArray(responseData);

      if (responseData?.status) {
        setJobTitles(responseData?.data);
      } else {
        toast.error(t(`Dashboard.No data Available`));
      }
    } catch (err) {
      toast.error(t(`Dashboard.No data Available`));
    }
  }

  useEffect(() => {
    GetCompanyData()
      .then(res => {
        let companyData = res?.data?.data || {};
        localStorage.setItem("company_type", companyData?.company_type);
        localStorage.setItem("linkedin_status", companyData?.linkedin);
        localStorage.setItem("company_theme", companyData?.company_theme);
        //setCountryId(companyData?.country_id)
      })
      .catch(err => {});
    handleTabTypeChange("current");
  }, []);

  useEffect(() => {
    const theme = localStorage.getItem("company_theme");
    if (theme) {
      document.body.classList.add(`theme-${theme}`);
    }
  }, []);
  useEffect(() => {
    setDashboardData("");
    if (tabType !== "custom") {
      getDashboardData(tabType);
    }
  }, [tabType]);

  const getAgendaData = async () => {
    await getTodayAgendaDetails(agendaDate)
      .then(res => {
        let responseData = decryptDataFromArray(res);

        setAgendaDetails(responseData?.data);
      })
      .catch(err => {});
  };

  const getDashboardData = async type => {
    let payload = `?type=${type}&startDate=${startDate}&endDate=${endDate}`;
    await FetchDashboardData(payload)
      .then(res => {
        let responseData = decryptDataFromArray(res);
        if (responseData?.status) {
          setDashboardData(responseData?.data);
          //call job-data
          getJobList(type, startDate, endDate);
        } else {
          //   setError("No data available");
        }
      })
      .catch(err => {
        toast.error(
          err?.response?.data?.message || t(`Dashboard.Something Went Wrong.`),
          {
            position: toast.POSITION.TOP_RIGHT,
          }
        );
        // setError("No data Available");
      });
  };

  //hide-showw-in mobile-view
  const [showDetails, setShowDetails] = useState(false); // State for calendar visibility

  const handleCloseClick = () => {
    setShowDetails(false); // Hide the calendar when the cross is clicked
  };

  const handleButtonClick = () => {
    setShowDetails(prev => !prev); // Toggle the state when button is clicked
  };

  // Function to check screen width and set visibility
  const checkWidth = () => {
    if (window.innerWidth > 1366) {
      if (getSubdomain() !== "mahindra") {
        setShowDetails(true); // Show calendar if the width is greater than 1366px
      }
    } else {
      setShowDetails(false); // Hide calendar if the width is less than or equal to 1366px
    }
  };

  useEffect(() => {
    // Initial check for screen width
    checkWidth();

    // Add event listener for resize
    window.addEventListener("resize", checkWidth);

    // Cleanup function to remove the event listener
    return () => {
      window.removeEventListener("resize", checkWidth);
    };
  }, []);


  const { instance, accounts } = useMsal();

  const login = async () => {
    await instance.loginPopup();
    instance
      .acquireTokenSilent({
        account: accounts[0],
      })
      .then(response => {
        localStorage.setItem("teamsAccessToken", response.accessToken);
        //console.log('teamsAccessToken',localStorage.getItem(teamsAccessToken));
        //callMeetingAPI(response);
      });
  };

  // const [isFixed, setIsFixed] = useState(true);

  // useEffect(() => {
  //   const handleScroll = () => {
  //     if (window.scrollY > 100) {
  //       // Change 100 to the scroll position where you want to start fixing the div
  //       setIsFixed(true);
  //     } else {
  //       setIsFixed(false);
  //     }
  //   };

  //   window.addEventListener("scroll", handleScroll);
  //   return () => {
  //     window.removeEventListener("scroll", handleScroll);
  //   };
  // }, []);

  const dateToString = date => date.toISOString();
  let duplicate_job_param = "";
  if (dashboardData?.totalDuplicates?.filter_type == "custom") {
    let encStartDate = dateToString(startDate);
    let encEndDate = dateToString(endDate);
    duplicate_job_param =
      "custom?startDate=" + encStartDate + "&endDate=" + encEndDate;
  } else {
    duplicate_job_param = dashboardData?.totalDuplicates?.filter_type;
  }

  return (
    <div className="dashboard-main-container">
      <div className="inner-wrapper dashboard-card-between">
        <div
          className={`tabbing-wrapper d-flex justify-content-between mt-2 mb-4 fixed-tabbing-wrapperss
          }`}
        >
          <div className="tab-head d-flex align-items-lg-center justify-content-lg-between">
            <ul className="tab-btn-wrapper d-flex align-items-center">
              <li>
                <Link
                  onClick={() => handleTabTypeChange("current")}
                  to={"/dashboard"}
                  className={`tab-link ${
                    tabType === "current" ? "active" : ""
                  }`}
                  id="current-month"
                >
                  {t(`Dashboard.Current Month`)}
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => {
                    handleTabTypeChange("previous");
                  }}
                  to={"/dashboard"}
                  className={`tab-link ${
                    tabType === "previous" ? "active" : ""
                  }`}
                  id="last-month"
                >
                  {t(`Dashboard.Last 3 Months`)}
                </Link>
              </li>
              <li>
                <Link
                  onClick={() => handleTabTypeChange("custom")}
                  to={"/dashboard"}
                  className={`tab-link ${tabType === "custom" ? "active" : ""}`}
                  id="custom"
                >
                  {t(`Dashboard.Custom`)}
                </Link>
              </li>
            </ul>
          </div>

          <div className="filter-wrapper-card dashboard-card">
            <div className="ml-auto post-job d-flex align-items-center gap-2">
              {/* <button onClick={login} className="btn btn-primary">
              Login
            </button> */}
              <Link to="/create-job-new" className="btn btn-primary">
                <svg
                  className="me-1"
                  aria-hidden="true"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  width="20"
                  height="20"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke="currentColor"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M5 12h14m-7 7V5"
                  />
                </svg>{" "}
                {t(`Dashboard.Post New Job`)}
              </Link>
            </div>
          </div>
        </div>

        <div className="tab-content" id="pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="pills-home"
            role="tabpanel"
            // aria-labelledby="pills-home-tab"
          >
            <div className="outerTab-box-wrapper  dashboard-card">
              {tabType === "custom" && (
                <div className="filter-wrapper custome-datemobile gap-3 d-flex align-items-center">
                  <div controlId="formDate" className="input-formtext d-flex">
                    {/* <span>Start Date :</span> */}
                    <DatePicker
                      placeholder={t(`Dashboard.Start Date`)}
                      className="form-control"
                      type={"date"}
                      title={`${t(`Dashboard.Start Date`)}`}
                      onChange={e => {
                        setStartDate(e);
                        saveDashboardFilterDates(e, "");
                      }}
                      placeholderText={t(`Dashboard.Start Date`)}
                      id="date"
                      selected={startDate}
                      maxDate={endDate || new Date()} // Restrict selection to today
                    />
                    {/* <span className="calender-icon form">
                      <img src={calender_icon} alt="" />
                    </span> */}
                  </div>

                  <div controlId="formDate" className="input-formtext d-flex">
                    {/* <span>End Date :</span> */}
                    <DatePicker
                      placeholder={t(`Dashboard.End Date`)}
                      className="form-control"
                      type={"date"}
                      onChange={e => {
                        setEndDate(e);
                        saveDashboardFilterDates("", e);
                      }}
                      title={`${t(`Dashboard.End Date`)}`}
                      placeholderText={t(`Dashboard.End Date`)}
                      id="date"
                      selected={endDate}
                      minDate={startDate} // Restrict end date to be after start date
                      maxDate={new Date()} // Restrict selection to today
                    />
                    {/* <span className="calender-icon form">
                      <img src={calender_icon} alt="" />
                    </span> */}
                  </div>

                  <button
                    className="btn btn-primary search"
                    onClick={() => {
                      getDashboardData("custom");
                      saveDashboardFilterType("custom");
                    }}
                  >
                    {t(`Dashboard.Search`)}
                  </button>
                </div>
              )}

              <div className="card-columns">
                {/* Total Applications */}
                <div class="tabBox-wrapper">
                  <Link to="/all-applications?filterValue=true">
                    <div class="tab-details">
                      <div class="d-flex align-items-center">
                        <div class="tab-value">
                          {dashboardData?.counts?.totalApplicants || 0}
                        </div>
                        <div class="tab-ico ms-auto">
                          <img
                            src="../img/TotalApplications.svg"
                            alt="TotalApplications"
                            className="total-app"
                          />

                          <img
                            src="../img/TotalApplicationshover.svg"
                            alt="TotalApplicationshover"
                            className="total-app-hover"
                          />
                        </div>
                      </div>
                      <h2 class="tab-title">
                        {t(`Dashboard.Total Applications`)}
                        <img
                          src={arrow}
                          alt="Chevron Icon"
                          class="right-chevron"
                        />
                      </h2>
                    </div>
                  </Link>
                </div>

                {/* Pending Applications */}

                <div class="tabBox-wrapper new-app">
                  <Link to="/pending-list?filterValue=true">
                    <div class="tab-details">
                      <div class="d-flex align-items-center">
                        <div class="tab-value">
                          {dashboardData?.counts?.pendingCount || 0}
                        </div>
                        <div class="tab-ico ms-auto">
                          <img
                            src="../img/NewApplications.svg"
                            alt="NewApplications"
                            className="total-app"
                          />

                          <img
                            src="../img/NewApplicationshover.svg"
                            alt="TotalApplicationshover"
                            className="total-app-hover"
                          />
                        </div>
                      </div>
                      <h2 class="tab-title">
                        {t(`Dashboard.New Applications`)}{" "}
                        <img
                          src={arrow}
                          alt="Chevron Icon"
                          class="right-chevron"
                        />
                      </h2>
                    </div>
                  </Link>
                </div>
                {/* Screening Test */}
                {/* <Card
                  imageSrc="../img/screening-Test.svg"
                  title={
                    <>
                      Screening Test{" "}
                      {
                        <img
                          src={arrow}
                          alt="Chevron Icon"
                          className="right-chevron"
                        />
                      }
                    </>
                  }
                  value={dashboardData?.counts?.screeningUsers || 0}
                  link={"/screening-list"}
                /> */}

                {/* Scheduled Interviews */}

                <div class="tabBox-wrapper underassement">
                  <Link to="/screening-list?filterValue=true">
                    <div class="tab-details">
                      <div class="d-flex align-items-center">
                        <div class="tab-value">
                          {dashboardData?.counts?.scheduledUsers +
                            dashboardData?.counts?.screeningUsers || 0}
                        </div>
                        <div class="tab-ico ms-auto">
                          <img
                            src="../img/UnderAssessment.svg"
                            alt="UnderAssessment"
                            className="total-app"
                          />

                          <img
                            src="../img/UnderAssessmenthover1.svg"
                            alt="UnderAssessment"
                            className="total-app-hover"
                          />
                        </div>
                      </div>
                      <h2 class="tab-title">
                        {t(`Dashboard.Under Assessment`)}{" "}
                        <img
                          src={arrow}
                          alt="Chevron Icon"
                          class="right-chevron"
                        />
                      </h2>
                    </div>
                  </Link>
                </div>

                {/* Selected Applicants */}

                <div class="tabBox-wrapper  SelectedApplicants">
                  <Link to="/selected-list?filterValue=true">
                    <div class="tab-details">
                      <div class="d-flex align-items-center">
                        <div class="tab-value">
                          {dashboardData?.counts?.selectedUsers || 0}
                        </div>
                        <div class="tab-ico ms-auto">
                          <img
                            src="../img/SelectedApplicants.svg"
                            alt="SelectedApplicants"
                            className="total-app"
                          />

                          <img
                            src="../img/SelectedApplicantshover.svg"
                            alt="SelectedApplicants"
                            className="total-app-hover"
                          />
                        </div>
                      </div>
                      <h2 class="tab-title">
                        {t(`Dashboard.Selected Applications`)}{" "}
                        <img
                          src={arrow}
                          alt="Chevron Icon"
                          class="right-chevron"
                        />
                      </h2>
                    </div>
                  </Link>
                </div>

                {/* On-hold Applicants */}
                <div class="tabBox-wrapper hold-Applicants">
                  <Link to="/onhold-list?filterValue=true">
                    <div class="tab-details">
                      <div class="d-flex align-items-center">
                        <div class="tab-value">
                          {dashboardData?.counts?.onholdUsers || 0}
                        </div>
                        <div class="tab-ico ms-auto">
                          <img
                            src="../img/On-hold-Applicants.svg"
                            alt="On-hold-Applicants"
                            className="total-app"
                          />

                          <img
                            src="../img/rejecthovr.svg"
                            alt="RejectedApplicants"
                            className="total-app-hover"
                          />
                        </div>
                      </div>
                      <h2 class="tab-title">
                        {t(`Dashboard.On-hold Applications`)}{" "}
                        <img
                          src={arrow}
                          alt="Chevron Icon"
                          class="right-chevron"
                        />
                      </h2>
                    </div>
                  </Link>
                </div>

                {/* Onboarded Applicants */}

                <div class="tabBox-wrapper  OnboardedApplicants">
                  <Link to="/onboarded-list?filterValue=true">
                    <div class="tab-details">
                      <div class="d-flex align-items-center">
                        <div class="tab-value">
                          {dashboardData?.counts?.onboardedUsers || 0}
                        </div>
                        <div class="tab-ico ms-auto">
                          <img
                            src="../img/OnboardedApplicants.svg"
                            alt="OnboardedApplicants"
                            className="total-app"
                          />

                          <img
                            src="../img/OnboardedApplicanthvr.svg"
                            alt="OnboardedApplicants"
                            className="total-app-hover"
                          />
                        </div>
                      </div>
                      <h2 class="tab-title">
                        {t(`Dashboard.Onboarded Applications`)}{" "}
                        <img
                          src={arrow}
                          alt="Chevron Icon"
                          class="right-chevron"
                        />
                      </h2>
                    </div>
                  </Link>
                </div>

                {/* Rejected Applicants */}

                <div class="tabBox-wrapper RejectedApplicants">
                  <Link to="/rejected-list?filterValue=true">
                    <div class="tab-details">
                      <div class="d-flex align-items-center">
                        <div class="tab-value">
                          {dashboardData?.counts?.rejectedUsers || 0}
                        </div>
                        <div class="tab-ico ms-auto">
                          <img
                            src="../img/RejectedApplicants.svg"
                            alt="RejectedApplicants"
                            className="total-app"
                          />

                          <img
                            src="../img/rejectapphover.svg"
                            alt="RejectedApplicants"
                            className="total-app-hover"
                          />
                        </div>
                      </div>
                      <h2 class="tab-title">
                        {t(`Dashboard.Rejected Applications`)}{" "}
                        <img
                          src={arrow}
                          alt="Chevron Icon"
                          class="right-chevron"
                        />
                      </h2>
                    </div>
                  </Link>
                </div>

                <div class="tabBox-wrapper TotalDuplicatesJobs">
                  <Link to={`/archive-list?filterValue=true`}>
                    <div class="tab-details">
                      <div class="d-flex align-items-center">
                        <div class="tab-value">
                          {dashboardData?.counts?.archivedUsers || 0}
                        </div>
                        <div class="tab-ico ms-auto">
                          <img
                            src="../img/TotalDuplicatesJobs.svg"
                            alt="ArchivedApplicants"
                            className="total-app"
                          />

                          <img
                            src="../img/TotalDuplicatesobs.svg"
                            alt="ArchivedApplicants"
                            className="total-app-hover"
                          />
                        </div>
                      </div>
                      <h2 class="tab-title">
                        {t(`Dashboard.Archived Applications`)}{" "}
                        <img
                          src={arrow}
                          alt="Chevron Icon"
                          class="right-chevron"
                        />
                      </h2>
                    </div>
                  </Link>
                </div>

                {/* <div class="tabBox-wrapper TotalDuplicatesJobs">
                  <Link to={`/view-duplicate-job/${duplicate_job_param}`}>
                    <div class="tab-details">
                      <div class="d-flex align-items-center">
                        <div class="tab-value">
                          {dashboardData?.totalDuplicates?.Total || 0}
                        </div>
                        <div class="tab-ico ms-auto">
                          <img
                            src="../img/TotalDuplicatesJobs.svg"
                            alt="TotalDuplicatesJobs"
                            className="total-app"
                          />

                          <img
                            src="../img/TotalDuplicatesobs.svg"
                            alt="TotalDuplicatesJobs"
                            className="total-app-hover"
                          />
                        </div>
                      </div>
                      <h2 class="tab-title">
                        {t(`Dashboard.Total Duplicates Job`)}{" "}
                        <img
                          src={arrow}
                          alt="Chevron Icon"
                          class="right-chevron"
                        />
                      </h2>
                    </div>
                  </Link>
                </div> */}
              </div>

              <div className="col-lg-12">
                <FunnelChart
                  data={dashboardData?.funnelData || ""}
                  jobTitles={jobTitles || ""}
                  type={tabType || ""}
                  startDate={startDate || ""}
                  endDate={endDate || ""}
                />
                <TimeToHire data={dashboardData?.vacanciesWithMinDays || []} />

                <Row className="pt-4 dropout-cardss">
                  {" "}
                  <Col xl={6} lg={12}>
                    {}
                    {subdomain !== "mahindra" && (
                      <DropoutMatrix data={dashboardData?.dropoutMatrix} />
                    )}
                    {subdomain !== "mahindra" && (
                      <HiringAcceptanceChart
                        acceptanceDetails={
                          dashboardData?.acceptanceDetails || {}
                        }
                      />
                    )}

                    {/* {subdomain === "mahindra" && (
                      <NewApplicantChart
                        acceptanceDetails={
                          dashboardData?.acceptanceDetails || {}
                        }
                      />
                    )} */}
                  </Col>
                  <Col xl={6} lg={12}>
                    <HiringCharts
                      pieChartData={dashboardData?.pieChartData || []}
                      type={tabType || ""}
                      startDate={startDate || ""}
                      endDate={endDate || ""}
                      jobTitles={jobTitles}
                    />
                  </Col>
                </Row>

                <Vacancytable data={dashboardData?.vacancyTypeData || []} />
                {/* <VacancyTable2 /> */}

                <RangeTableComponent data={jobTitles} />
           
              </div>

              <div className="col-lg-12">
                <DemographicChart
                  type={tabType || ""}
                  startDate={startDate || ""}
                  endDate={endDate || ""}
                />
                {/*<DuplicateJobApplied data={dashboardData?.duplicateAppliedJobData || []} /> */}
              </div>

              {/* <div className="col-lg-12">
                <Eligibleapplication />
                <Pendingapplication data={dashboardData?.PendingList || []} />
              </div> */}

              {/* <div className="create-job-vacancy mt-5 d-md-flex align-items-center">
                <div className="job-vacancy-sec">
                  <div className="col-pic">
                    <img src="../img/creat-job-ico.svg" alt="" />
                  </div>
                  <h3 className="heading-three">Create a Job Vacancy</h3>
                  <p>
                    Embark on the journey of creating a job vacancy to welcome
                    talented individuals into your team.
                  </p>
                  <Link
                    href="javascript:void()"
                    className="btn btn-primary mt-3"
                  >
                    <svg
                      className="me-2"
                      aria-hidden="true"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      width="20"
                      height="20"
                      viewBox="0 0 24 24"
                    >
                      <path
                        stroke="currentColor"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M5 12h14m-7 7V5"
                      />
                    </svg>{" "}
                    Post New Job
                  </Link>
                </div>
                <div className="sec-pic">
                  <img src="../img/new-vacancy.svg" alt="" />
                </div>
              </div> */}
            </div>
          </div>
        </div>
      </div>
      {getSubdomain() !== "mahindra" && (
        <div className="agenda-btn-mobile">
          <button
            className="btn btn-primary agedna-click"
            onClick={handleButtonClick}
          >
            {t(`Dashboard.Agenda View Details`)}
          </button>
        </div>
      )}
      {getSubdomain() !== "mahindra" && (   <div
        className={`dashboard-timeline ${showDetails ? "show-details" : ""}`}
      >
        <div className="filter-content cross" onClick={handleCloseClick}>
          <img src={cross} alt="Close" />
        </div>
        {showDetails && (
          <DashboardDateTime
            data={agendaDetails || ""}
            setAgendaDate={setAgendaDate}
            agendaDate={agendaDate}
          />
        )}{" "}
        {/* Show calendar if state is true */}
      </div>)}
   
    </div>
  );
};

export default RecruitmentDashboard;
